import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { TestCase } from '@/domain/value_objects/testCase/TestCase'
import { JudgeCaseModuleName } from '@/store/modules/modules'

export class JudgeCaseViewModel {
  private store = useStore()

  judgeCaseList: ComputedRef<TestCase[]> = computed(() => this.store.getters[`${JudgeCaseModuleName}/judgeCaseList`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${JudgeCaseModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${JudgeCaseModuleName}/error`])

  async getJudgeCaseList(problemId: string): Promise<void> {
    await this.store.dispatch(`${JudgeCaseModuleName}/getJudgeCaseList`, { problemId })
  }
}
